import { SAVED_SUCCESSFULLY_SURVEY } from '../../utils/surveyLiterals'
export const savedSuccessFullySurvey = (payload) => {
    return {
        type: SAVED_SUCCESSFULLY_SURVEY,
        payload: payload
    }
}

